import React from 'react'
import classNames from 'classnames'

import BreadCrumb from './Breadcrumb'
import NotificationsDropdown from '../NotificationsPanel/NotificationsDropdown'
import OrganizationDropdown from './OrganizationDropdown'

import TopbarInviteLink from './TopbarInviteLink'
import DirectEdit from './DirectEdit'
import enhance from './enhance'
import { EnhancedTopBarLabel } from './Label/TopBarLabel'

export const TOP_BAR_HEIGHT = 58

export type TopBarRightProps = {
  noteId: string
}

export const TopBarRight = ({ noteId }: TopBarRightProps) => (
  <div
    className={classNames(
      'l-topbar-right',
      'overflow-hidden',
      'width-full padding-vertical-normal padding-left-medium zindex-large',
      'background-shade-100 border-bottom-medium border-shade-50',
      'flexbox flexbox-align-center'
    )}
    style={{ height: TOP_BAR_HEIGHT }}
  >
    <EnhancedTopBarLabel noteId={noteId} />
    <BreadCrumb />
    <div className="padding-vertical-normal flexbox flexbox-no-grow flexbox-no-shrink flexbox-justify-end background-shade-100">
      <div className="flexbox flexbox-align-center">
        <DirectEdit />
      </div>
      <div className="flexbox flexbox-align-center">
        <TopbarInviteLink />
      </div>
      <div className="flexbox flexbox-align-center">
        <NotificationsDropdown />
      </div>
      <div className="flexbox flexbox-align-center padding-left-smaller padding-right-medium">
        <OrganizationDropdown />
      </div>
    </div>
  </div>
)

export const EnhancedTopBarRight = enhance(TopBarRight)
